import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import {
  BulkEditEffects,
  SurveyEffects,
  SurveyReferenceEffects,
  SurveySocketEffects,
  SurveyActivityLogEffects,
  SupplierEffects,
  surveyFeature,
} from './state';

export const SURVEY_STORE_PROVIDERS = {
  feature: provideState(surveyFeature),
  effects: provideEffects(
    SurveyEffects,
    BulkEditEffects,
    SurveyReferenceEffects,
    SurveySocketEffects,
    SurveyActivityLogEffects,
    SupplierEffects,
  ),
};
